import { ProductTier, PurchaseableTier } from '@sparemin/api-sdk';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { onUnlockThisFeature } from 'redux/modules/mixpanel/actions';
import { hideModal, replaceModal } from 'redux/modules/modal';

import FileSizeUpsellDialog from './FileSizeUpsellDialog';
import { Variant } from './types';

const { useCallback } = React;

export interface Props {
  fake?: boolean;
  variant?: Variant;
}

const FileSizeUpsellModalContents = (props: Props) => {
  const { variant = 'default' } = props;

  const dispatch = useDispatch();

  const closeModal = useCallback(() => {
    dispatch(hideModal());
  }, [dispatch]);

  const handleShowCheckoutModal = useCallback(
    (tier: PurchaseableTier) => {
      dispatch(
        replaceModal({
          name: 'AddBillingCycle',
          params: {
            tier,
            defaultSubscriptionPeriod: 'yearly',
            disableSuccessRedirect: true,
          },
        }),
      );
    },
    [dispatch],
  );

  const handleUpgrade = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      if (variant === 'default') {
        dispatch(onUnlockThisFeature('IncreaseSizeLimitVideoTranscription'));
      }
      handleShowCheckoutModal(ProductTier.PRO);
    },
    [dispatch, handleShowCheckoutModal, variant],
  );

  return (
    <FileSizeUpsellDialog
      variant={variant}
      actions={[
        variant === 'file' && {
          children: 'no thanks',
          key: 'negative-cta',
          onClick: closeModal,
          theme: 'cancel' as const,
        },
        {
          children: 'increase your upload limit',

          componentClass: Link,
          key: 'positive-cta',
          to: '/settings/my-plan',
          theme: 'rainbow' as const,
          onClick: handleUpgrade,
        },
      ].filter(Boolean)}
    />
  );
};

export default FileSizeUpsellModalContents;
